<template>
  <q-dialog
    v-model="showDialog"
    v-bind="$attrs"
    persistent
    v-on="$listeners"
    @hide="onCancel"
  >
    <q-card style="min-width: 50vw">
      <q-card-section>
        <div class="text-h6">
          Motif de fin de service anticipé
        </div>
        <q-select
          v-model="motif"
          :options="$options.motifs"
          @input="content = null"
        />
        <q-input
          v-if="motif"
          v-model="content"
          :label="motif.label"
          type="textarea"
        />
      </q-card-section>
      <dialog-component-footer
        :disable="!(content && motif)"
        @submit="onSubmit"
      />
    </q-card>
  </q-dialog>
</template>

<script>
import dialogComponentMixin from 'components/Dialog/dialogComponentMixin'
import DialogComponentFooter from 'components/Dialog/DialogComponentFooter'

export default {
  name: 'DialogMotifFinDeService',
  components: { DialogComponentFooter },
  mixins: [dialogComponentMixin],
  motifs: [
    { label: `J'ai été relevé par :`, value: 'releve' },
    { label: 'Autre (préciser)', value: 'other' }
  ],
  data () {
    return {
      motif: null,
      content: null
    }
  },
  methods: {
    onCancel () {
      this.showDialog = false
      this.$emit('cancel')
    },
    onSubmit () {
      const { motif: { label }, content } = this
      this.showDialog = false
      this.$emit('ok', {
        content: [label, content].join(' ')
      })
    }
  }
}
</script>

<style scoped>

</style>
